<template>
<div>
    <v-layout justify-center align-center wrap mt-5>
        <v-flex xs10 md6 mt-4 v-if="data.length != 0">      
            <carrusel-app :data="data"/>
        </v-flex>
    </v-layout> 
  </div>
</template>
<script>
import resourcesLoader from '../../js/mixins/resources-loader'
export default {
  mixins:[resourcesLoader],
    components:{
        CarruselApp: () => import('../../components/carousel')
    },
  data() {
    return {
      vistos: Array(9).fill(false),
      rotation: 0,
      activeCard: 1,
      jsonRoute:'datajson/unidad2/carrusel',
      data:{}
    }
  },
  created() {
    this.getJson(this.jsonRoute, data => {
      this.data = data
    })
    console.log(JSON.stringify(this.data))
    
  },
 
}
</script>
<style lang="scss" scoped>
</style>
